import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-cgu-en-modal',
  templateUrl: './cgu-en-modal.component.html',
  styleUrls: ['./cgu-en-modal.component.scss']
})
export class CguEnModalComponent implements OnInit {
  constructor(private _ngxSmartModalService: NgxSmartModalService) {}

  ngOnInit(): void {}

  private closeModal() {
    this._ngxSmartModalService.close('cguEnModal');
  }
}
